module.exports = __webpack_public_path__ + "media/images/x-square_white-37d2bd5f.svg";